import { render, staticRenderFns } from "./PFreeApplyActionArea.vue?vue&type=template&id=0f63c0b3&scoped=true&"
import script from "./PFreeApplyActionArea.vue?vue&type=script&lang=ts&"
export * from "./PFreeApplyActionArea.vue?vue&type=script&lang=ts&"
import style0 from "./PFreeApplyActionArea.vue?vue&type=style&index=0&id=0f63c0b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f63c0b3",
  null
  
)

export default component.exports